import { useClipboardFeedback } from "@/shared/useClipboardFeedback";
import { IconCheck, IconCopy } from "./icons";

/** Bottone copia-negli-appunti con feedback legato all'azione. Usato per ID
 *  ordine e SKU (2026-07-06). Ora thin wrapper su ``useClipboardFeedback``. */
export function CopyButton({ text, label }: { text: string; label: string }) {
  const { copied, copy } = useClipboardFeedback();

  return (
    <button
      type="button"
      data-no-open
      title={copied ? "Copiato!" : label}
      aria-label={copied ? "Copiato negli appunti" : label}
      className={[
        "w-[18px] h-[18px] shrink-0 inline-grid place-items-center rounded-[3px] border-none bg-transparent transition-colors",
        copied ? "text-green" : "text-ink hover:bg-paper-2 hover:text-ink",
      ].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
        void copy(text);
      }}
    >
      {copied ? (
        <IconCheck className="w-[11px] h-[11px] fill-none stroke-current stroke-[3] [stroke-linecap:round] [stroke-linejoin:round]" />
      ) : (
        <IconCopy className="w-[11px] h-[11px] fill-none stroke-current stroke-[1.6] [stroke-linecap:round] [stroke-linejoin:round]" />
      )}
    </button>
  );
}
